import { render } from "./InventoryDetails.vue?vue&type=template&id=382e459e&scoped=true"
import script from "./InventoryDetails.vue?vue&type=script&lang=js"
export * from "./InventoryDetails.vue?vue&type=script&lang=js"

import "./InventoryDetails.vue?vue&type=style&index=0&id=382e459e&scoped=true&lang=css"

import exportComponent from "/kaam/build/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382e459e"]])

export default __exports__